import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form/Form';
import MultilingualForm from './Form/MultilingualForm';
import Modal from 'react-bootstrap/lib/Modal';
import ModalHeader from './ModalHeader';
import { formatClassName, pickDataAttributes } from '../Util';

export default class ModalForm extends React.Component {
  static propTypes = {
    bsSize: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.any,
    container: PropTypes.instanceOf(Element),
    data: PropTypes.object,
    languages: PropTypes.arrayOf(PropTypes.object),
    modalProps: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    saveAndAddButton: PropTypes.bool,
    show: PropTypes.bool,
    size: PropTypes.string,
    title: PropTypes.string
  };

  static defaultProps = {
    container: null,
    size: 'medium'
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  buildForm = () => {
    if (this.props.data) {
      let commonProps = {
        buttonGroupClass: "modal-footer sticky-footer",
        fieldGroupClass: "modal-body",
        horizontal: true,
        onCancel: this.onCancel,
        onCancelClose: this.onCancelClose,
        scrollContainerId: "form-modal",
        saveAndAddButton: this.props.saveAndAddButton !== undefined ? this.props.saveAndAddButton : !this.props.data.id,
        triggerCancel: this.state.triggerCancel
      };
      if (this.props.languages) {
        return (
          <MultilingualForm {...this.props} {...commonProps} >
            {this.props.children}
          </MultilingualForm>
        );
      } else {
        return (
          <Form {...this.props} {...commonProps}>
            {this.props.children}
          </Form>
        );
      }
    }
  }

  onCancelClose = () => this.setState({ triggerCancel: false });

  onCancel = () => {
    this.setState({ triggerCancel: false });
    this.props.onCancel();
  }

  onHide = () => this.setState({ triggerCancel: true });

  getModalClasses = () => {
    const { className, size } = this.props;
    return formatClassName([
      `${className}`,
      'form-modal',
      `modal-size-${size}`
    ])
  }

  render() {
    const modalClassName = this.getModalClasses();
    const dataAttributes = pickDataAttributes(this.props);

    return (
      <Modal
        bsSize={this.props.bsSize}
        className={modalClassName}
        id="form-modal"
        onHide={this.onHide}
        show={this.props.show === undefined ? !!this.props.data : this.props.show}
        container={this.props.container}
      >
        <ModalHeader
          {...dataAttributes}
          canClickOff={true}
          onCancel={this.onHide}
          title={this.props.title}
        />
        {this.buildForm()}
      </Modal>
    );
  }
}
